import {filler, vframe} from '@xh/hoist/cmp/layout';
import {hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {TransactionsTabModel} from './TransactionsTabModel';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {button} from '@xh/hoist/desktop/cmp/button';
import {Icon} from '@xh/hoist/icon';
import {chart} from '@xh/hoist/cmp/chart';
import {grid} from '@xh/hoist/cmp/grid';
import './TransactionsTab.scss';

export const transactionsTab = hoistCmp.factory<TransactionsTabModel>(({model}) =>
    panel({
        model: model.panelModel,
        omit: !model.isVisible,
        tbar: toolbar({
            compact: true,
            items: [
                Icon.chartArea(),
                'Transactions',
                filler(),
                button({
                    icon: model.panelModel.isModal ? Icon.collapse() : Icon.expand(),
                    onClick: () => model.panelModel.toggleIsModal()
                }),
                button({icon: Icon.x(), onClick: () => model.close()})
            ]
        }),
        item: vframe(chart({height: 300}), grid({agOptions: model.agOptions})),
        mask: 'onLoad'
    })
);
